import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { add_section } from "../../actions/ExpenseBucket";
import ExpenseBucketSection from "./ExpenseBucketSection"

const ExpenseBucketModule = (props) => {
    const dispatch = useDispatch();
    const ExpenseBucket = useSelector((state) => state.ExpenseBucket);

    return <>
        <div className="card shadow-sm border-0">
            <div className="card-header bg-primary text-white">
                <h6 className="mb-0">
                    <i className="bi bi-collection me-2"></i>
                    Export-Buckets
                </h6>
            </div>
            <div className="card-body p-0">
                <ul className="list-group list-group-flush">
                    {Object.keys(ExpenseBucket.sections).map(e => {
                        return <ExpenseBucketSection key={e} forceTreeReload={props.forceTreeReload} uuid={e} />
                    })}
                </ul>
            </div>
            <div className="card-footer bg-white border-0">
                <button
                    className="btn btn-outline-primary w-100"
                    onClick={() => {dispatch(add_section())}}
                >
                    <i className="bi bi-plus-circle me-2"></i>
                    Neuer Abschnitt
                </button>
            </div>
        </div>
    </>
} 

export default ExpenseBucketModule;